import React from 'react';
import classnames from 'classnames';

import { useStore } from '../../store';

interface MemoryCardTagsProps {
  tags: number[];
  size?: 's' | 'm' | 'l';
  readOnly?: boolean;
};

const MemoryCardTags: React.FC<MemoryCardTagsProps> = ({ tags, size, readOnly }) => {
  const { tags: availableTags } = useStore((state) => state.settings || { tags: [] });

  if (tags.length === 0) return null;

  return (
    <div className={classnames('memory-card-tags', 'memory-tags', 'wa-cluster', 'wa-gap-xs', { 'memory-tags--read-only': readOnly})}>
      {tags.map((tagId: number) => {
        const tag = availableTags.find((t) => t.id === tagId);
        if (!tag) return null;

        return (
          <wa-tag
            key={`tag-${tag.id}`}
            size={size || 'xs'}
            pill
            className="memory-tag memory-tag--selected"
          >
            {tag.name}
          </wa-tag>
        );
      })}
    </div>
  );
}

export default MemoryCardTags;
